<template>
  <div class="ma-0 pa-4 px-16 fill-height full-width main_container">
    <v-overlay :value="loading">
      <v-progress-circular color="#00C1B6" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="mb-4 mt-10 d-flex justify-space-between align-end">
      <!-- TITULO -->
      <span class="titulo mx-0">
        Boletim sanitário
      </span>
      <!-- BOLETIM SANITARIO -->
      <novo-boletim-sanitario-dialog>
        <template v-slot:activator="{ on }">
          <v-btn class="white--text" color="#00C1B6" v-on="on">
            Criar Novo
          </v-btn>
        </template>
      </novo-boletim-sanitario-dialog>
    </div>
    <v-row dense class="my-4 mx-0 d-flex justify-space-between align-end">
<!-- BUSCAR -->

      <!-- nmProdutor -->
      <v-text-field class="mr-2" color="white" solo hide-details
                    placeholder="Busque pelo nome do produtor"
                    clearable
                    v-model="filtroBusca.nmProdutor" @click:clear="limparBusca"
                    @keydown.enter="loadListaBoletimSanitario" />

      <!-- nrLoteControle -->
      <v-text-field class="mr-2" color="white" solo hide-details
                    placeholder="Busque pelo número do lote de controle" clearable
                    v-model="filtroBusca.nrLoteControle" @click:clear="limparBusca"
                    @keydown.enter="loadListaBoletimSanitario" />

      <!-- idBoletimSanitario -->
      <v-text-field color="white" solo hide-details placeholder="Busque pelo número do boletim sanitário" clearable
                    v-model="filtroBusca.idBoletimSanitario" @click:clear="limparBusca"
                    @keydown.enter="loadListaBoletimSanitario">
        <template v-slot:append>
          <v-btn color="#799596" :loading="loading" text @click="loadListaBoletimSanitario">BUSCAR</v-btn>
        </template>
      </v-text-field>
    </v-row>
    <!-- GRID MERCADOS      -->
    <div class="pa-0 mt-4 d-flex flex-column align-stretch" v-if="listaBoletimSanitario.length > 0">
      <v-row class="mb-0">
        <v-col xl="6" md="6" cols="12">
          <boletim-sanitario-card v-for="boletim in listaBoletimSanitarioEsq"
                                  :key="'boletim_card_esq__' + boletim.idBoletimSanitario"
                                  :boletim="listaBoletimSanitario[boletim.id]"
                                  @cancelarBoletim="cancelarBoletim(boletim.id)"
          />
        </v-col>
        <v-col xl="6" md="6" cols="12">
          <boletim-sanitario-card v-for="boletim in listaBoletimSanitarioDir"
                                  :key="'boletim_card_dir__' + boletim.idBoletimSanitario"
                                  :boletim="listaBoletimSanitario[boletim.id]"
                                  @cancelarBoletim="cancelarBoletim(boletim.id)"
          />
        </v-col>
      </v-row>
      <v-row dense class="mb-16 d-flex justify-center align-end">
        <v-pagination class="pb-0" color="#00C1B6" v-model="page" :length="totalPages" :total-visible="7" />
      </v-row>
    </div>
    <!-- ESTADO VAZIO      -->
    <v-container fluid class="pa-0 mt-8 d-flex align-start fill-height" v-else-if="!loading">
      <alert-sem-dados-para-etapa
          :titulo="`Não há boletim sanitário cadastrado ${!mensagemBusca ? '' : 'com o nome de ' + mensagemBusca}`"
          sub-titulo="Cadastre no botão CRIAR NOVO"></alert-sem-dados-para-etapa>
    </v-container>

  </div>
</template>

<script>
import AlertSemDadosParaEtapa from "../components/AlertSemDadosParaEtapa";
import BoletimSanitarioCard from "../components/pesquisaBoletimSanitario/BoletimSanitarioCard";
import NovoBoletimSanitarioDialog from "../components/pesquisaBoletimSanitario/NovoBoletimSanitarioDialog";
import {MOCKS, MODELS} from "../resources";

export default {
  name: "PesquisaBoletimSanitario",
  components: {AlertSemDadosParaEtapa, BoletimSanitarioCard, NovoBoletimSanitarioDialog},
  data: () => ({
    loading: false,
    filtroBusca: {
      nmProdutor: null,
      nrLoteControle: null,
      idBoletimSanitario: null,
    },
    mensagemBusca: '',
    totalPages: 1,
    page: 1,
    listaBoletimSanitario: []
  }),
  computed: {
    listaBoletimSanitarioEsq() {
      return this.listaBoletimSanitario.filter(
          (_, idx) => idx % 2 === 0)
    },
    listaBoletimSanitarioDir() {
      return this.listaBoletimSanitario.filter(
          (_, idx) => idx % 2 !== 0)
    },
  },
  methods: {
    cancelarBoletim(idx) {
      this.listaBoletimSanitario[idx].cdStatusBoletimSanitario = 6
    },
    limparBusca() {
      this.filtroBusca = {
        nmProdutor: null,
        nrLoteControle: null,
        idBoletimSanitario: null,
      }
      this.loadListaBoletimSanitario()
    },
    loadListaBoletimSanitario() {
      this.loading = true
      this.mensagemBusca = ''

      let query = new URLSearchParams()

      let cfNmProdutor = {"field": "nmProdutor", "op": "ilike", "value": `%${this.filtroBusca.nmProdutor}%`}
      let cfNrLoteControle = {"field": "nrLoteControle", "op": "ilike", "value": `%${this.filtroBusca.nrLoteControle}%`}

      if(this.filtroBusca.nmProdutor && this.filtroBusca.nmProdutor !== '') {
        this.mensagemBusca = `produtor "${this.filtroBusca.nmProdutor}"`
        query.append("cf", JSON.stringify(cfNmProdutor))
      }

      if(this.filtroBusca.nrLoteControle && this.filtroBusca.nrLoteControle !== '') {
        this.mensagemBusca = `lote de controle "${this.filtroBusca.nmProdutor}"`
        query.append("cf", JSON.stringify(cfNrLoteControle))
      }

      if(this.filtroBusca.idBoletimSanitario && this.filtroBusca.idBoletimSanitario !== '') {
        this.mensagemBusca = `número de boletim "${this.filtroBusca.nmProdutor}"`
        query.append("idBoletimSanitario", this.filtroBusca.idBoletimSanitario)
      }

      query.append("per_page", '8')
      query.append("page", this.page)

      this.$axios.get(`boletim-sanitario/`, {params: query})
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) {
              this.listaBoletimSanitario = []
              this.totalPages = 1
              return
            }

            this.totalPages = res.data[0].meta.pages
            this.listaBoletimSanitario = res.data[0].data.map((boletim, idx) => _.extend(boletim, {id: idx}))
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
          .finally(() => this.loading = false)
    },
  },
  watch: {
    page() {
      this.loadListaBoletimSanitario()
    }
  },
  mounted() {
    this.loadListaBoletimSanitario()
  },
}
</script>

<style scoped>
.main_container {
  background-color: #f2f5f3;
  border-radius: 0 0 8px 8px;
}

.titulo {
  font: normal normal normal 32px/37px Roboto;
  color: #37565C;
  opacity: 0.8;
}

</style>